import {AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

@Component({
    selector: 'app-question-label-amount-json',
    templateUrl: './question-label-amount-json.component.html',
    styleUrls: ['./question-label-amount-json.component.scss'],
    standalone: false
})
export class QuestionLabelAmountJsonComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Input() showTotal = true;
  @Output() questionAnswer = new EventEmitter<any>();

  //questions: Question[] = [];
  questions: any = [];
  maskOptions: NgxCurrencyConfig;

  constructor(public globalQuestionService: GlobalQuestionService) {
    
  }

  ngOnInit(): void {
    if (this.question) {
      try {
        if (this.question.options) {
          this.questions = JSON.parse(this.question.options);
        } else {
          this.questions = JSON.parse(this.question.answer);
        }
      } catch { }
      
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: this.globalQuestionService?.currency?.symbol,
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  get totalAmount(): number {
    let total = 0;
    for (const a of this.questions) {
      total += +a.list_value;
    }
    return total;
  }

  saveValue(): void {
    if (this.question) {
      this.question.answer = JSON.stringify(this.questions);
      this.questionAnswer.emit(this.question);
    }
    
  }

}
